export default __webpack_public_path__ + "static/media/12.64df7375.jpg";